function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"])
    return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r))
    return _arrayLikeToArray(r); }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) {
    if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
        t && (r = t);
        var _n = 0, F = function F() { };
        return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
} var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try {
        a || null == t["return"] || t["return"]();
    }
    finally {
        if (u)
            throw o;
    } } }; }
function _unsupportedIterableToArray(r, a) { if (r) {
    if ("string" == typeof r)
        return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
} }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++)
    n[e] = r[e]; return n; }
import { theme } from '@/styles/theme';
import { z } from 'zod';
import Cookies from 'js-cookie';
/**
 * Get user information from the user cookie
 * @returns User object with id, username, name, and email
 */
export var getUserFromCookie = function getUserFromCookie() {
    try {
        var userCookie = Cookies.get('user');
        if (userCookie) {
            var _userObj$userAttribut, _userObj$userAttribut2;
            var userObj = JSON.parse(userCookie);
            return {
                id: (userObj === null || userObj === void 0 ? void 0 : userObj.id) || (userObj === null || userObj === void 0 ? void 0 : userObj.user_id) || '',
                username: (userObj === null || userObj === void 0 ? void 0 : userObj.username) || '',
                name: (userObj === null || userObj === void 0 || (_userObj$userAttribut = userObj.userAttributes) === null || _userObj$userAttribut === void 0 ? void 0 : _userObj$userAttribut.name) || '',
                email: (userObj === null || userObj === void 0 || (_userObj$userAttribut2 = userObj.userAttributes) === null || _userObj$userAttribut2 === void 0 ? void 0 : _userObj$userAttribut2.email) || ''
            };
        }
    }
    catch (error) {
        console.error('Error parsing user cookie:', error);
    }
    return {
        id: '',
        username: '',
        name: '',
        email: ''
    };
};
export function fileToBase64(file) {
    return new Promise(function (resolve, reject) {
        var reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = function () {
            return resolve(reader.result);
        };
        reader.onerror = reject;
    });
}
export var isAdminPolicy = function isAdminPolicy() {
    var _sessionStorage$getIt;
    var policy = JSON.parse((_sessionStorage$getIt = sessionStorage.getItem('policy')) !== null && _sessionStorage$getIt !== void 0 ? _sessionStorage$getIt : '[]');
    if (policy.length === 0)
        return false;
    return policy.some(function (item) {
        return item.name === 'Admin';
    });
};
var httpUrlSchema = z.string().refine(function (url) {
    try {
        var urlObj = new URL(url);
        return urlObj.protocol === 'http:' || urlObj.protocol === 'https:';
    }
    catch (_unused) {
        return false;
    }
}, {
    message: 'Invalid URL or URL must use HTTP or HTTPS protocol'
});
export var isValidHttpUrl = function isValidHttpUrl(url) {
    return httpUrlSchema.safeParse(url).success;
};
var extractActionsFromPolicy = function extractActionsFromPolicy(policy) {
    var actions = [];
    if (policy.resource_action && Array.isArray(policy.resource_action)) {
        // resource_action contains objects with action arrays
        var _iterator = _createForOfIteratorHelper(policy.resource_action), _step;
        try {
            for (_iterator.s(); !(_step = _iterator.n()).done;) {
                var resourceAction = _step.value;
                if (resourceAction.action && Array.isArray(resourceAction.action)) {
                    actions.push.apply(actions, _toConsumableArray(resourceAction.action));
                }
            }
        }
        catch (err) {
            _iterator.e(err);
        }
        finally {
            _iterator.f();
        }
    }
    return actions;
};
var addActionsToSet = function addActionsToSet(actions, effect, allowedActions, deniedActions) {
    if (effect === 'allow') {
        var _iterator2 = _createForOfIteratorHelper(actions), _step2;
        try {
            for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
                var act = _step2.value;
                allowedActions.add(act);
            }
        }
        catch (err) {
            _iterator2.e(err);
        }
        finally {
            _iterator2.f();
        }
    }
    else if (effect === 'deny') {
        var _iterator3 = _createForOfIteratorHelper(actions), _step3;
        try {
            for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
                var _act = _step3.value;
                deniedActions.add(_act);
            }
        }
        catch (err) {
            _iterator3.e(err);
        }
        finally {
            _iterator3.f();
        }
    }
};
export var isAuthorized = function isAuthorized(action) {
    try {
        var _sessionStorage$getIt2;
        // Get policies from sessionStorage
        var policies = JSON.parse((_sessionStorage$getIt2 = sessionStorage.getItem('policy')) !== null && _sessionStorage$getIt2 !== void 0 ? _sessionStorage$getIt2 : '[]');
        if (policies.length === 0) {
            return false;
        }
        // Separate allowed and denied actions
        var allowedActions = new Set();
        var deniedActions = new Set();
        // Process each policy
        var _iterator4 = _createForOfIteratorHelper(policies), _step4;
        try {
            for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
                var policy = _step4.value;
                try {
                    var _policy$effect;
                    // Extract actions from resource_action array
                    var actions = extractActionsFromPolicy(policy);
                    // Add actions to appropriate set based on effect
                    var effect = (_policy$effect = policy.effect) === null || _policy$effect === void 0 ? void 0 : _policy$effect.toLowerCase();
                    addActionsToSet(actions, effect, allowedActions, deniedActions);
                }
                catch (error) {
                    console.warn('Failed to process policy:', error);
                }
            }
            // Check authorization: action must be explicitly allowed and not denied
        }
        catch (err) {
            _iterator4.e(err);
        }
        finally {
            _iterator4.f();
        }
        return allowedActions.has(action) && !deniedActions.has(action);
    }
    catch (error) {
        console.error('Error in isAuthorized function:', error);
        return false;
    }
};
export var normalizeEmail = function normalizeEmail(email) {
    if (!(email !== null && email !== void 0 && email.includes('@'))) {
        throw new Error('Invalid email format');
    }
    // If it's already a standard email (e.g. abc@), return as is
    var excludeEmail = 'identity.deloitte';
    if (!email.endsWith(excludeEmail)) {
        return email;
    }
    // Otherwise, clean up Deloitte identity-style emails
    var localPart = email.split('@')[0];
    var lastUnderscoreIndex = localPart.lastIndexOf('_');
    if (lastUnderscoreIndex === -1) {
        throw new Error("Email format does not contain expected '_' separator");
    }
    var name = localPart.substring(0, lastUnderscoreIndex);
    var domainPart = localPart.substring(lastUnderscoreIndex + 1);
    // Ensure domain has '.com' if missing
    if (!domainPart.includes('.')) {
        domainPart += '.com';
    }
    return "".concat(name, "@").concat(domainPart);
};
export var getSelectedLanguageFromCookie = function getSelectedLanguageFromCookie() {
    try {
        var _user$details;
        var userCookie = Cookies.get('user');
        if (!userCookie) {
            return 'en';
        }
        var user = JSON.parse(userCookie);
        var selectedLanguage = user === null || user === void 0 || (_user$details = user.details) === null || _user$details === void 0 ? void 0 : _user$details.selected_language;
        if (selectedLanguage && typeof selectedLanguage === 'string') {
            return selectedLanguage.trim().toLowerCase();
        }
        return 'en';
    }
    catch (error) {
        console.error('Error reading selected_language from cookie:', error);
        return 'en';
    }
};
export var SETTINGS_VALIDATION = {
    nameAllowedChars: /^[A-Za-z .-]+$/,
    nameHasLetter: /[A-Za-z]/,
    maxNameLength: 50,
    reloadDelay: 100
};
/**
 * Lighten a hex color by an amount (0 to 1).
 * @param {string} hex - The hex color, e.g., "#26890D"
 * @param {number} amount - How much to lighten (0.2 = 20% lighter)
 * @returns {string} The new hex color
 */
export var getLightColorCode = function getLightColorCode() {
    var _hex;
    var hex = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : theme.palette.primary.dark;
    var amount = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0.4;
    // Remove hash
    hex = (_hex = hex) === null || _hex === void 0 ? void 0 : _hex.replace('#', '');
    // Parse r,g,b
    var r = Number.parseInt(hex.substring(0, 2), 16);
    var g = Number.parseInt(hex.substring(2, 4), 16);
    var b = Number.parseInt(hex.substring(4, 6), 16);
    // Calculate new values
    r = Math.round(r + (255 - r) * amount);
    g = Math.round(g + (255 - g) * amount);
    b = Math.round(b + (255 - b) * amount);
    // Ensure stays in range and convert back to hex
    var toHex = function toHex(n) {
        return n.toString(16).padStart(2, '0');
    };
    return "#".concat(toHex(r)).concat(toHex(g)).concat(toHex(b));
};
export var getDefaultApplication = function getDefaultApplication() {
    return {
        appName: 'ConvergeExperience',
        appId: '0' // Instance of env
    };
};
export var isGenericGreenColor = function isGenericGreenColor(color) {
    return color === '#26890D';
};
export function arrayBufferToBase64(buffer) {
    if (!buffer)
        return null;
    var bytes = new Uint8Array(buffer);
    var binary = '';
    for (var i = 0; i < bytes.byteLength; i++) {
        binary += String.fromCodePoint(bytes[i]);
    }
    return btoa(binary);
}
export var getEmailFromSession = function getEmailFromSession() {
    var sessionObj = sessionStorage.getItem('current_application');
    if (sessionObj) {
        var _JSON$parse$details;
        return ((_JSON$parse$details = JSON.parse(sessionObj).details) === null || _JSON$parse$details === void 0 ? void 0 : _JSON$parse$details.contactEmail) || 'convergeconsumer@deloitte.com';
    }
    return 'convergeconsumer@deloitte.com';
};
